/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import moment from 'moment/moment';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { formatMonth } from '../../data/format-month';
import { bilimMerkezAPI, merkezMedia } from '../../api';
import BlurImage from '../../component/blur-image';
import Loading from '../../component/Loading';

const BlogSidebar = (props) => {
  const { t } = useTranslation();
  const [news, setNews] = useState([]);
  const language = localStorage.getItem('i18nextLng');
  const [loading, setLoading] = useState(true);
  const formatDate = (date) => {
    const month = date?.split('T')[0].split('-')[1];
    return `${formatMonth(month, language)} ${moment(date).format(`DD, YYYY`)}`;
  };

  useEffect(() => {
    const lang = language === 'tk' ? 'tm' : language;
    let params = {
      limit: 7,
      offset: 0,
    };
    setLoading(true);
    bilimMerkezAPI
      .get(
        `/competition/?offset=${params.offset}&limit=${params.limit}&lang=${lang}`
      )
      .then((req) => {
        setNews(req.data.results);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, [language]);

  return (
    <section className="tw-w-full tw-my-12">
      <h4 className="tw-text-2xl tw-font-semibold tw-mb-6">
        {t('other_competitions')}
      </h4>
      {loading ? (
        <div className="tw-w-full tw-flex tw-flex-row tw-justify-center tw-items-center">
          <Loading style={{ width: '10%' }} />
        </div>
      ) : (
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-5">
          {news
            .filter((item) => item.id !== Number(props.news_id))
            .slice(0, 6)
            .map((item) => (
              <Link
                key={item.id}
                to={`/competition-details/${item.id}`}
                className="tw-group tw-flex tw-flex-row tw-overflow-hidden tw-rounded-md tw-bg-white tw-shadow tw-transition-shadow tw-duration-300 hover:tw-shadow-lg"
              >
                <BlurImage
                  className="tw-basis-2/5 tw-shrink-0 tw-aspect-[3/2]"
                  imgClassName="tw-transition-transform tw-duration-300 group-hover:tw-scale-105"
                  src={merkezMedia(item.image_thumbnail || item.image)}
                  alt={item.title}
                />
                <div className="tw-flex tw-flex-1 tw-min-w-0 tw-flex-col tw-justify-between tw-gap-3 tw-p-4">
                  <div className="tw-line-clamp-3 tw-font-semibold tw-leading-snug tw-text-black tw-transition-colors tw-duration-300 group-hover:tw-text-primary">
                    {item.title}
                  </div>
                  <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-text-gray-400">
                    <img
                      src="/images/calendar.svg"
                      className="tw-size-4"
                      alt=""
                    />
                    {formatDate(item.published_date)}
                  </div>
                </div>
              </Link>
            ))}
        </div>
      )}
    </section>
  );
};

export default BlogSidebar;
